import { useMemo } from 'react';

import { useSelector } from '@xstate5/react';

import { type LocationSearchMachineContext, type LocationSearchService } from '../../machine';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Returns the searched locations with the outpost results always stripped from
 * the pickup tab.
 */
export const useLocationSearchVisibleLocations = (params: Params) => {
  const { locationSearchActorRef } = params;

  const locations = useSelector(locationSearchActorRef, (snapshot) => snapshot.context.locations);

  const locationSearchType = useSelector(
    locationSearchActorRef,
    (snapshot) => snapshot.context.locationSearchType,
  );

  // ─── Derived ─────────────────────────────────────────────────────────

  return useMemo<LocationSearchMachineContext['locations']>(() => {
    if (!locations) return locations;

    if (locationSearchType === 'pickup') {
      return { ...locations, outpost: [] };
    }

    return locations;
  }, [locations, locationSearchType]);
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  locationSearchActorRef: LocationSearchService;
};
